/**
 * Shared wire contract for screen-share reaction broadcasts (server + client).
 */

/** Broadcast payload for Message.ADD_REACTION (server/rooms/Wiggin.ts -> phaserEvents 'screenShareReaction'). */
export interface ReactionBroadcastPayload {
  emoji: string
  author: string
  timestamp: number
}

/** The only emoji clients may send with Message.ADD_REACTION — kept in sync with the reaction bar UI. */
export const ALLOWED_REACTION_EMOJI = new Set(['👍', '👏', '😂', '❤️', '🎉', '😮'])
